/**
 * TemplatePreview - Componente para pré-visualizar um template
 * 
 * Mostra uma prévia do formulário do template em modo somente leitura.
 */

import React from 'react'
import { TemplateFormRenderer } from './TemplateFormRenderer'
import type { TemplateSchema } from '../types'
import { cn } from '../../../utils/formatter'
import { HiEye } from 'react-icons/hi'

interface TemplatePreviewProps {
  /** Schema do template para preview */
  templateSchema: TemplateSchema | null
  /** Classes CSS adicionais */
  className?: string
}

/**
 * Componente de pré-visualização de template
 */
export const TemplatePreview: React.FC<TemplatePreviewProps> = ({
  templateSchema,
  className,
}) => {
  if (!templateSchema) {
    return null
  }

  return (
    <div className={cn('rounded-lg border border-gray-200 dark:border-neutral-700 overflow-hidden', className)}>
      {/* Header */}
      <div className="flex items-center gap-2 px-4 py-3 bg-gray-50 dark:bg-neutral-800 border-b border-gray-200 dark:border-neutral-700">
        <HiEye className="w-4 h-4 text-gray-500 dark:text-gray-400" />
        <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
          Pré-visualização do Template
        </span>
        <span className="text-xs text-gray-500 dark:text-gray-400 ml-auto">
          v{templateSchema.versao}
        </span>
      </div>

      {/* Preview do formulário */}
      <div className="p-4 bg-white dark:bg-neutral-900">
        <TemplateFormRenderer
          templateSchema={templateSchema}
          formData={{}}
          onChange={() => {}}
          disabled={true}
          readonly={true}
          showSubmitButton={false}
        />
      </div>

      {/* Footer com informações */}
      <div className="px-4 py-2 bg-amber-50 dark:bg-amber-900/20 border-t border-amber-200 dark:border-amber-800">
        <p className="text-xs text-amber-700 dark:text-amber-300">
          💡 Esta é uma pré-visualização. Os campos serão preenchidos pelo usuário ao criar a demanda.
        </p>
      </div>
    </div>
  )
}

export default TemplatePreview
